import React from "react";
import styled from "styled-components";
import breakpoints from "Helpers/BreakpointHelper/";
import media from "styled-media-query";
import { SearchWrapper } from "Components/Search/hits";

export const Input = styled.input.attrs(
	({ margin, smallmargin, border, padding, height, theme }) => ({
		type: "text",
		margin: margin ? margin : smallmargin ? smallmargin : 0,
		smallmargin: smallmargin ? smallmargin : margin ? margin : 0,
		padding: padding ? padding : "0 1rem",
		border: border ? border : `1px solid ${theme.colors.grey}`,
		height: height ? height : media.greaterThan(breakpoints.ipad) ? "58px" : "48px",
	})
)`
	outline: none;
	height: ${({height}) => (height ? height : "48px")};
	width: 100%;
	border: ${({border}) => border};
	font-size: 16px;
	padding: ${({padding}) => padding};
	font-family: ${({theme}) => theme.font};
		/* border-radius: ${({theme}) => theme.border.radius}; */

	${SearchWrapper} & {
		border-radius: ${({theme}) => `${theme.border.radius} 0 0 ${theme.border.radius}`};
	}

	margin: ${(props) => props.smallmargin};

	${media.greaterThan(breakpoints.ipad)`
        margin: ${({margin}) => margin};
        height: ${({height}) => (height ? height : "48px")};
	`}
	transition: 0.2s ease;

	&:focus {
		outline-offset: 5px;
		outline: ${({theme}) => theme.colors.primaryDark} solid 2px;
	}
`;

export const RoundedInput = styled(Input)`
	border-radius: 50px;
`;

export const RoundInputWrapper = styled.div.attrs(({ maxwidth }) => ({
	maxwidth: maxwidth ? maxwidth : "none",
}))`
	position: relative;
	padding: ${({ padding }) => (padding ? padding : "")};
	width: 100%;
	display: flex;
	align-items: center;
	flex-direction: row;
	max-width: ${({ maxwidth }) => maxwidth};
	${media.lessThan(breakpoints.mobile)`
        flex-direction: ${({ smallcolumn }) => (smallcolumn ? "column" : "")} ;
    `}
`;
export const RichInput = styled.textarea.attrs(
	({ margin, smallmargin, border, padding, height, theme }) => ({
		type: "text",
		margin: margin ? margin : smallmargin ? smallmargin : 0,
		smallmargin: smallmargin ? smallmargin : margin ? margin : 0,
		padding: padding ? padding : "0 1rem",
		border: border ? border : `1px solid ${theme.colors.grey}`,
		height: height ? height : media.greaterThan(breakpoints.ipad) ? "58px" : "48px",
	})
)`
	border-radius: ${({ theme }) => theme.border.radius};

	outline: none;
	height: ${({ height }) => (height ? height : "48px")};
	width: 100%;
	border: ${({ border }) => border};
	font-size: 16px;
	padding: ${({ padding }) => padding};
	font-family: ${({ theme }) => theme.font};
	margin: ${(props) => props.smallmargin};

	${media.greaterThan(breakpoints.ipad)`
        margin: ${({ margin }) => margin};
        height: ${({ height }) => (height ? height : "48px")};
	`}
	transition: 0.2s ease;
	&:focus {
		outline-offset: 5px;
		outline: ${({theme}) => theme.colors.primaryDark} solid 2px;
	}
`;
